import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import expandIcon from "../../../assets/icons/expand_icon.svg";
import DOMPurify from "dompurify";
import { handleAuthenticatedDownload } from "../../../utils/downloadUtils";
import Loader from "../loader/Loader";

const isHtmlString = (str) => {
  let htmlTagRegex = /<[a-z][\s\S]*>/i;
  return str && str.match(htmlTagRegex);
};

const MAX_HEIGHT = 70;

const FileDescription = ({ description, title, isDisabled, downloadUrl }) => {
  const [height, setHeight] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { t } = useTranslation("common");
  const ref = useRef(null);
  const containerRef = useRef(null);

  const showExpandButton = height >= MAX_HEIGHT;

  const descriptionClassName = `filedescription${
    isExpanded ? " filedescription--expanded" : ""
  }${showExpandButton ? " filedescription--isBig" : ""} text-small`;

  useEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  useEffect(() => {
    const tr = containerRef.current?.closest("tr");
    if (!tr) return;
    if (isDownloading) {
      tr.style.backgroundColor = "#f0f0f0";
      tr.style.opacity = "0.7";
    } else {
      tr.style.backgroundColor = "";
      tr.style.opacity = "";
    }
  }, [isDownloading]);

  return (
    <div ref={containerRef}>
      <div className="filename-header">
        {!isDisabled && (
          <>
            <a
              href={downloadUrl}
              className="filename text-small"
              aria-label={`${t("documents.list.content.openFile")} ${title}`}
              onClick={(e) =>
                handleAuthenticatedDownload(e, downloadUrl, setIsDownloading)
              }
            >
              {title}
            </a>
            {isDownloading && <Loader type="inline" />}
          </>
        )}
        {showExpandButton && (
          <button
            className="step__expand-btn"
            onClick={(e) => {
              e.preventDefault();
              setIsExpanded((prevState) => !prevState);
            }}
          >
            <img
              className={`step__expand-icon${isExpanded ? " open" : ""}`}
              src={expandIcon}
              alt=""
            />
          </button>
        )}
      </div>
      <div ref={ref} className="filedescription-wrapper">
        {isHtmlString(description) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description),
            }}
            className={descriptionClassName}
          ></div>
        ) : (
          <div className={descriptionClassName}>
            <span>{description}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileDescription;
